export const compareStatuses = {
  0: 'text-red',
  1: 'text-orange',
  2: 'text-green'
}

export const compareStatusesBg = {
  0: '#db2828',
  1: '#FE9A76',
  2: '#32CD32'
}

export const listtingComparesStatus = {
  0: 'text-grey',
  1: 'text-orange',
  2: 'text-blue',
  3: 'text-purple',
  4: 'text-green'
}

export const listtingComparesStatusBg = {
  0: '#A0A0A0',
  1: '#FE9A76',
  2: '#0E6EB8',
  3: '#B413EC',
  4: '#32CD32'
}

export const listtingComparesError = {
  1: 'text-red',
  2: 'text-red',
  3: 'text-red',
  4: 'text-red',
  5: 'text-red',
  6: 'text-red',
  7: 'text-red',
}

export const listtingComparesErrorBg = {
  1: '#db2828',
  2: '#db2828',
  3: '#db2828',
  4: '#db2828',
  5: '#db2828',
  6: '#db2828',
  7: '#db2828'
}



// WEBPACK FOOTER //
// ./src/stubs/compares.js